import React from 'react'

const IconOpenBook = ({ height, modifiers }) => {
  return (
    <svg
      className={`icon icon-open-book ${modifiers}`}
      style={{height}}
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 291.7 203.5"
    >
      <path d="M291.7,36.8v149.8c0,2.2-1.8,3.9-3.9,3.9H181.3v9c0,2.2-1.8,3.9-3.9,3.9h-63.1c-2.2,0-3.9-1.8-3.9-3.9v-9H3.9
        c-2.2,0-3.9-1.8-3.9-3.9V36.8c0-2.2,1.8-3.9,3.9-3.9h17.4v15.8h-5.6v126.2h94.6h15.8v13h39.4v-13h15.8H276V48.6h-5.6V32.8h17.4
        C290,32.8,291.7,34.6,291.7,36.8z M238.3,39.7c0-2,0-3.9,0-5.9c-23.5-7.2-48.7-7.2-72.2,0c0,2,0,3.9,0,5.9
        C189.6,32.6,214.8,32.6,238.3,39.7z M238.3,109.7c0-2,0-3.9,0-5.9c-23.5-7.2-48.7-7.2-72.2,0c0,2,0,3.9,0,5.9
        C189.6,102.5,214.8,102.5,238.3,109.7z M231.7,125.3c0-2,0-3.9,0-5.9c-21.6-5.3-44.3-4.7-65.6,1.8c0,2,0,3.9,0,5.9
        C187.4,120.7,210.1,120.1,231.7,125.3z M213,87.3c0-2,0-3.9,0-5.9c-15.7-1.4-31.7,0.3-46.9,4.9c0,2,0,3.9,0,5.9
        C181.4,87.5,197.3,85.9,213,87.3z M234.6,73.6c0-2,0-3.9,0-5.9c-22.5-6.1-46.2-5.7-68.5,1.1c0,2,0,3.9,0,5.9
        C188.4,67.9,212.2,67.6,234.6,73.6z M228.5,54.7c0-2,0-3.9,0-5.9c-20.6-4.5-42.1-3.6-62.4,2.5c0,2,0,3.9,0,5.9
        C186.4,51,207.9,50.2,228.5,54.7z M33.2,163.8c0-50.1,0-100.2,0-150.2c35.4-18,77.3-18,112.7,0c35.4-18,77.3-18,112.7,0
        c0,50.1,0,100.2,0,150.2c-35.4-18-77.3-18-112.7,0C110.5,145.7,68.6,145.7,33.2,163.8z M161.1,141.5c26.6-9.4,55.7-9.4,82.3,0
        c0-39.6,0-79.1,0-118.7c-26.6-9.4-55.7-9.4-82.3,0C161.1,62.4,161.1,101.9,161.1,141.5z M48.4,141.5c26.6-9.4,55.7-9.4,82.3,0
        c0-39.6,0-79.1,0-118.7c-26.6-9.4-55.7-9.4-82.3,0C48.4,62.4,48.4,101.9,48.4,141.5z M125.6,39.7c0-2,0-3.9,0-5.9
        c-23.5-7.2-48.7-7.2-72.2,0c0,2,0,3.9,0,5.9C76.9,32.6,102.1,32.6,125.6,39.7z M125.6,109.7c0-2,0-3.9,0-5.9
        c-23.5-7.2-48.7-7.2-72.2,0c0,2,0,3.9,0,5.9C76.9,102.5,102.1,102.5,125.6,109.7z M119,125.3c0-2,0-3.9,0-5.9
        c-21.6-5.3-44.3-4.7-65.6,1.8c0,2,0,3.9,0,5.9C74.8,120.7,97.4,120.1,119,125.3z M100.3,87.3c0-2,0-3.9,0-5.9
        c-15.7-1.4-31.7,0.3-46.9,4.9c0,2,0,3.9,0,5.9C68.7,87.5,84.6,85.9,100.3,87.3z M121.9,73.6c0-2,0-3.9,0-5.9
        c-22.5-6.1-46.2-5.7-68.5,1.1c0,2,0,3.9,0,5.9C75.7,67.9,99.5,67.6,121.9,73.6z M115.9,54.7c0-2,0-3.9,0-5.9
        c-20.6-4.5-42.1-3.6-62.4,2.5c0,2,0,3.9,0,5.9C73.7,51,95.2,50.2,115.9,54.7z"/>
  </svg>
  )
}

IconOpenBook.defaultProps = {
  height: "6rem",
  modifiers: "",
}

export default IconOpenBook
